// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mudcheck-tile {
  border: 1px solid #000;
  padding: 8px;
  margin: 0 0 10px 0;
  width: 100%;
  box-sizing: border-box;
}
.mudcheck-tile .header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 12px;
}
.mudcheck-tile .left {
  display: flex;
  align-items: center;
  gap: 8px;
}
.mudcheck-tile .status-marker {
  display: inline-block;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  flex: 0 0 auto;
}
.mudcheck-tile .title {
  background: none;
  border: none;
  text-align: left;
  cursor: pointer;
  font-size: 1rem;
  text-decoration: underline;
}
.mudcheck-tile .name {
  font-weight: 700;
  margin-right: 6px;
}
.mudcheck-tile .desc {
  color: #666;
}
.mudcheck-tile .body {
  margin: 8px 0;
}
.mudcheck-tile .remove-material {
  background: none;
  border: 0;
  color: #6c757d;
  cursor: pointer;
  padding: 0 2px;
  vertical-align: middle;
}
.mudcheck-tile .remove-material mat-icon {
  font-size: 18px;
  height: 18px;
  width: 18px;
}
.mudcheck-tile .test {
  display: inline-flex;
  align-items: center;
  margin-right: 8px;
  font-size: 0.95rem;
  margin-bottom: 4px;
}
.mudcheck-tile .status-dot {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 6px;
}
.mudcheck-tile .status-pass {
  background-color: #28a745;
}
.mudcheck-tile .status-fail {
  background-color: #dc3545;
}
.mudcheck-tile .status-pending {
  background-color: #ffc107;
}
.mudcheck-tile .status-unknown {
  background-color: #6c757d;
}
.mudcheck-tile .test-title {
  white-space: nowrap;
}
.mudcheck-tile .footer {
  display: flex;
  gap: 8px;
  justify-content: flex-start;
  flex-wrap: wrap;
}
.mudcheck-tile .btn {
  padding: 6px 10px;
  font-size: 0.95rem;
}
.mudcheck-tile .icon {
  background: none;
  border: none;
  cursor: pointer;
  font-size: 18px;
  line-height: 1;
  padding: 0 4px;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/job-details/mud-check-tile/mud-check-tile.component.scss"],"names":[],"mappings":"AAAA;EACE,sBAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;EACA,sBAAA;AACF;AACE;EAAU,aAAA;EAAc,8BAAA;EAA+B,uBAAA;EAAwB,SAAA;AAKjF;AAJE;EAAQ,aAAA;EAAc,mBAAA;EAAoB,QAAA;AAS5C;AARE;EAAiB,qBAAA;EAAsB,WAAA;EAAY,YAAA;EAAa,kBAAA;EAAmB,cAAA;AAerF;AAdE;EAAS,gBAAA;EAAiB,YAAA;EAAa,gBAAA;EAAiB,eAAA;EAAgB,eAAA;EAAgB,0BAAA;AAsB1F;AArBE;EAAQ,gBAAA;EAAiB,iBAAA;AAyB3B;AAxBE;EAAQ,WAAA;AA2BV;AAzBE;EAAQ,aAAA;AA4BV;AA3BE;EACE,gBAAA;EACA,SAAA;EACA,cAAA;EACA,eAAA;EACA,cAAA;EACA,sBAAA;AA6BJ;AA3BE;EAA4B,eAAA;EAAiB,YAAA;EAAc,WAAA;AAgC7D;AA/BE;EAAQ,oBAAA;EAAqB,mBAAA;EAAoB,iBAAA;EAAkB,kBAAA;EAAkB,kBAAA;AAsCvF;AArCE;EAAc,qBAAA;EAAsB,WAAA;EAAY,YAAA;EAAa,kBAAA;EAAmB,iBAAA;AA4ClF;AA3CE;EAAe,yBAAA;AA8CjB;AA7CE;EAAe,yBAAA;AAgDjB;AA/CE;EAAkB,yBAAA;AAkDpB;AAjDE;EAAkB,yBAAA;AAoDpB;AAnDE;EAAc,mBAAA;AAsDhB;AApDE;EAAU,aAAA;EAAc,QAAA;EAAS,2BAAA;EAA4B,eAAA;AA0D/D;AAzDE;EAAO,iBAAA;EAAkB,kBAAA;AA6D3B;AA5DE;EAAQ,gBAAA;EAAiB,YAAA;EAAa,eAAA;EAAgB,eAAA;EAAgB,cAAA;EAAe,cAAA;AAoEvF","sourcesContent":[".mudcheck-tile {\n  border: 1px solid #000;\n  padding: 8px;\n  margin: 0 0 10px 0;\n  width: 100%;\n  box-sizing: border-box;\n\n  .header { display:flex; justify-content:space-between; align-items:flex-start; gap:12px; }\n  .left { display:flex; align-items:center; gap:8px; }\n  .status-marker { display:inline-block; width:12px; height:12px; border-radius:50%; flex:0 0 auto; }\n  .title { background:none; border:none; text-align:left; cursor:pointer; font-size:1rem; text-decoration:underline; }\n  .name { font-weight:700; margin-right:6px; }\n  .desc { color:#666; }\n\n  .body { margin:8px 0; }\n  .remove-material {\n    background: none;\n    border: 0;\n    color: #6c757d;\n    cursor: pointer;\n    padding: 0 2px;\n    vertical-align: middle;\n  }\n  .remove-material mat-icon { font-size: 18px; height: 18px; width: 18px; }\n  .test { display:inline-flex; align-items:center; margin-right:8px; font-size:.95rem; margin-bottom:4px; }\n  .status-dot { display:inline-block; width:10px; height:10px; border-radius:50%; margin-right:6px; }\n  .status-pass { background-color: #28a745; }\n  .status-fail { background-color: #dc3545; }\n  .status-pending { background-color: #ffc107; }\n  .status-unknown { background-color: #6c757d; }\n  .test-title { white-space:nowrap; }\n\n  .footer { display:flex; gap:8px; justify-content:flex-start; flex-wrap:wrap; }\n  .btn { padding:6px 10px; font-size:.95rem; }\n  .icon { background:none; border:none; cursor:pointer; font-size:18px; line-height:1; padding:0 4px; }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
